import React from 'react';
import {
  FormControl, FormControlLabel, InputLabel, MenuItem,
  Select, Stack, Switch, TextField,
} from '@mui/material';

/**
 * Top-level product fields: name, description, category, base price,
 * currency, status, plus the inventory + shipping toggles.
 */
export default function ProductBasicsFields({ form, setForm }) {
  const set = (k, v) => setForm({ ...form, [k]: v });
  return (
    <>
      <TextField
        size='small' required label='Name'
        value={form.name}
        onChange={(e) => set('name', e.target.value)}
        fullWidth
      />
      <TextField
        size='small' multiline rows={3}
        label='Description'
        value={form.description}
        onChange={(e) => set('description', e.target.value)}
        fullWidth
      />
      <Stack direction={{ xs: 'column', md: 'row' }} spacing='10px'>
        <TextField
          size='small' label='Category'
          value={form.category}
          onChange={(e) => set('category', e.target.value)}
          placeholder='e.g. apparel'
          sx={{ flex: 1 }}
        />
        <TextField
          size='small' type='number' label='Base price'
          inputProps={{ min: '0', step: '0.01' }}
          value={form.base_price}
          onChange={(e) => set('base_price', e.target.value)}
          sx={{ flex: 1 }}
        />
        <TextField
          size='small' label='Currency'
          value={form.currency}
          onChange={(e) => set('currency', e.target.value.toUpperCase().slice(0, 3))}
          sx={{ maxWidth: 120 }}
        />
        <FormControl size='small' sx={{ maxWidth: 160, minWidth: 130 }}>
          <InputLabel>Status</InputLabel>
          <Select
            label='Status'
            value={form.status}
            onChange={(e) => set('status', e.target.value)}
          >
            <MenuItem value='draft'>Draft</MenuItem>
            <MenuItem value='active'>Active</MenuItem>
            <MenuItem value='archived'>Archived</MenuItem>
          </Select>
        </FormControl>
      </Stack>
      <Stack direction='row' spacing='20px' flexWrap='wrap'>
        <FormControlLabel
          control={
            <Switch
              checked={!!form.track_inventory}
              onChange={(e) => set('track_inventory', e.target.checked)}
            />
          }
          label='Track inventory'
        />
        <FormControlLabel
          control={
            <Switch
              checked={!!form.requires_shipping}
              onChange={(e) => set('requires_shipping', e.target.checked)}
            />
          }
          label='Requires shipping'
        />
      </Stack>
    </>
  );
}
